import { use } from 'react';

import {
  AuthState,
  AuthStateContext,
  AuthStateType,
} from '../contexts/AuthState';

export function useAuth() {
  const context = use(AuthStateContext);
  return [
    context.state,
    {
      signIn: context.signIn,
      signUp: context.signUp,
      signOut: context.signOut,
      setOnboardingState: context.setOnboardingState,
      refreshUser: context.refreshUser,
    },
  ] as const;
}

export { type AuthState, AuthStateType };
